import endpoints, { axios } from "../config/api";

function getProjectTemplates(page: number = 1, search: string = "") {
  return axios.get(endpoints.projectTemplates.getPage(page, search));
}

export default getProjectTemplates;
